import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
// import AdminLayout from '@/components/AdminLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'
import NotFoundPage from '@/views/NotFoundPage.vue'
import { beforeEachGuard, afterEachGuard, onErrorGuard } from './guards'
import { useUserStore } from '@/stores'
import HomePage from '@/views/homePage/HomePage.vue'
import notLogRouter from './notLogRouter'
import { convertMenuToRoutes } from '@/utils/menuUtils'


// 异步加载认证页面以优化性能
const AuthPage = () => import('@/views/login-in-register/index.vue')

// 定义路由配置
const routes = [
    // 使用空白布局的路由（如登录页面）
    {
        path: '/auth',
        component: BlankLayout,
        redirect: '/auth',
        children: [
            {
                path: '',
                name: 'auth',
                component: AuthPage,
                meta: {
                    title: '登录 - 无人车开放平台',
                    requiresAuth: false,
                    hideForAuth: true // 已登录用户不应访问
                }
            }
        ]
    },

    // 使用默认布局的路由（包含头部导航）
    {
        path: '/',
        name: 'root',
        component: DefaultLayout,
        children: []
    },
    // },
    // {
    //     path: '/AdminLayout',
    //     name: 'AdminLayout',
    //     component: AdminLayout,
    //     children: []

    // },

    {
        path: '/login',
        redirect: '/auth'
    },


    {
        path: '/register',
        redirect: to => {
            return { path: '/auth', query: { mode: 'register', ...to.query } }
        }
    },

    // 隐私政策页面
    {
        path: '/privacy',
        name: 'privacy',
        component: () => import('@/views/privacy/index.vue'),
        meta: {
            title: '隐私政策 - 无人车开放平台',
            requiresAuth: false
        }
    },

    // 使用条款页面
    {
        path: '/terms',
        name: 'terms',
        component: () => import('@/views/terms/index.vue'),
        meta: {
            title: '使用条款 - 无人车开放平台',
            requiresAuth: false
        }
    },

    // {
    //     path: '/cloudApi/api1',
    //     name: 'cloudApi/api1',
    //     component: () => import('@/views/cloudApi/components/api/api1.vue'),
    //     meta: {
    //         title: '使用条款 - 无人车开放平台',
    //         requiresAuth: false
    //     }
    // },


    {
        path: '/:pathMatch(.*)*',
        name: 'notFound',
        component: NotFoundPage,
        meta: {
            title: '页面未找到 - 无人车开放平台',
            requiresAuth: false
        }
    }
]

// 创建路由实例
const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        // 如果有保存的位置（比如浏览器后退），则恢复
        if (savedPosition) {
            return savedPosition
        }
        // 否则，滚动到顶部
        return { top: 0, behavior: 'smooth' }
    }
})

// 路由加载状态
let routesLoaded = false


// 添加根路径重定向
router.addRoute('root', {
    path: '',
    name: 'rootRedirect',
    redirect: '/home'
})

routesLoaded = true

// 初始化时注册未登录路由
registerNotLogRoutes()

// 导出路由加载状态检查函数
export const isRoutesLoaded = () => routesLoaded

// 注意：buildMenuTree函数已移至 @/utils/menuUtils.js 统一管理

// 注意：convertMenuTreeToRoutes函数已移至 @/utils/menuUtils.js 统一管理

// 注意：convertMenuToRoutes函数已移至 @/utils/menuUtils.js 统一管理

// 注册未登录状态下的路由
export function registerNotLogRoutes() {
    try {
        const routes = convertMenuToRoutes(notLogRouter, { isDynamic: false })
        routes.forEach(route => {
            router.addRoute('root', route)
        })
    } catch (error) {
        console.error('注册未登录路由失败:', error)
    }
}

// 清除未登录路由
export function clearNotLogRoutes() {
    const existingRoutes = router.getRoutes()
    existingRoutes.forEach(route => {
        if (route.meta?.isNotLogRoute) {
            router.removeRoute(route.name)
        }
    })
}

// 动态路由注册函数
export function registerDynamicRoutes(menuData) {
    if (!menuData || menuData.length === 0) return

    // 清除之前的动态路由
    clearDynamicRoutes()

    try {
        // 使用统一的菜单转换工具，标记为动态路由
        const routes = convertMenuToRoutes(menuData, { isDynamic: true })

        // 注册新的动态路由
        routes.forEach(route => {
            try {
                // 将动态路由添加到root路由下
                router.addRoute('root', route)
            } catch (error) {
                console.error('注册单个动态路由失败:', route, error)
            }
        })

        console.log('动态路由注册成功:', routes.length, '个路由')
    } catch (error) {
        console.error('动态路由转换失败:', error)
    }
}

// 清除动态路由函数
export function clearDynamicRoutes() {
    const existingRoutes = router.getRoutes()
    existingRoutes.forEach(route => {
        if (route.meta?.isDynamic) {
            router.removeRoute(route.name)
        }
    })
}


// 注册路由守卫
router.beforeEach(beforeEachGuard)
router.afterEach(afterEachGuard)
// router.onError(onErrorGuard)

export default router
